// Multi-language
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
  fr: {
    front_end: {
      additional_info_get_results: 'Obtenir mes résultats',
      additional_info_missing: 'Il vous reste des champs manquants : ',
      additional_info_prio: 'Vos priorités des 12 prochains mois',
      best_practice: 'Bonne Pratique',
      bravo_resultat: 'Félicitations, vous avez terminé le test.<br/> Voici votre résultat !',
      bravo_resultats: 'Félicitations, vous avez terminé le test.<br/> Voici vos résultats !',
      continuer: 'Continuer',
      download_pdf: 'Télécharger le rapport (PDF)',
      email_needed: 'Nous en avons besoin pour vous envoyer vos résultats.',
      email_wrong: 'Please enter a valid professional email address.',
      expert_contact: 'ÊTRE CONTACTÉ PAR UN EXPERT',
      faire_pause: 'Faire une pause ?',
      loading_results: 'Merci pour vos informations, nous préparons vos résultats',
      missing_question: 'Vous n\'avez pas encore répondu à la question',
      pause_body_text: 'Vous pouvez quitter et reprendre ce diagnostic à tout moment, du moment que vous utilisez le même navigateur web. Il vous suffira de revenir sur la page d\'accueil du diagnostic et de saisir à nouveau votre adresse email.<br /><br />Avertissement : si vous supprimez votre cache ou vos cookies, votre progression sera perdue.',
      pause_exit: 'Mettre en pause',
      pause_title: 'Mettre en pause le diagnostic',
      pdf_generation: 'Génération du PDF en cours',
      plusieurs_choix: 'Plusieurs choix possibles',
      restart: 'Recommencer',
      restart_dismiss: 'Revenir aux résultats',
      restart_modal_text: 'Avertissement : en cliquant ci-dessous sur le bouton \"Recommencer\", vous perdrez les résultats de votre précédent test.',
      restart_modal_title: 'Recommencer le diagnostic',
      result_mini_score_bad: 'À améliorer',
      result_mini_score_good: 'Bravo',
      result_mini_score_medium: 'Peut mieux faire',
      result_recap_bad: 'À améliorer',
      result_recap_good: 'Bon',
      see_full_report: "Pour accéder à vos résultats détaillés, découvrir les <b>bonnes pratiques</b> de votre industrie et améliorer votre performance grâce à un <b>diagnostic personnalisé</b>, merci de remplir ce formulaire",
      start: "Commencer le test",
      valider: 'Valider',
      your_score: 'Votre score s\'élève à ',
    },
    meta_fields: {
      description: 'Audit en ligne pour évaluer la maturité en télématique embarquée et optimiser la performance de vos opérations terrain.',
      title: 'Évaluez votre maturité en matière de digitalisation des titres-restaurant',
    }
  },
  en: {
    front_end: {
      additional_info_get_results: 'Get my results',
      additional_info_missing: 'You have some missing fields: ',
      additional_info_prio: 'Your next 12-month priorities',
      best_practice: 'Best Practice',
      bravo_resultats: 'Congratulations! You\'ve finished the test. Here are your results:',
      continuer: 'Continue',
      download_pdf: 'Download Report (PDF)',
      email_needed: 'We need it to send you your results.',
      email_wrong: 'Please enter a valid professional email address.',
      expert_contact: 'GET A CALL WITH US',
      faire_pause: 'Need a little break?',
      loading_results: 'Thank you for the information. We\'re loading your results.',
      missing_question: 'You have not yet answered question',
      pause_body_text: 'You can leave and resume this survey at any time, as long as you use the same web browser. All you have to do is go back to the survey home page and re-enter your email address.<br /><br />Warning: If you delete your cache or cookies, your progress will be lost.',
      pause_exit: 'Browse away',
      pause_title: 'Pause the survey and come back later...',
      pdf_generation: 'PDF Generation',
      plusieurs_choix: 'Multiple choices are possible',
      restart: 'RESTART',
      restart_dismiss: 'Back to my results',
      restart_modal_text: 'Warning : by clicking the \'Restart\' button below, you will find all results from your previous test.',
      restart_modal_title: 'Restart the assesment',
      result_mini_score_bad: 'To improve',
      result_mini_score_good: 'Perfect!',
      result_mini_score_medium: 'Rather good job',
      result_recap_bad: 'Can do better',
      result_recap_good: 'Good',
      see_full_report: "To access your detailed results, discover the <b>industry best practices<br/> and improve your performance thanks to a <b>customized diagnosis<br/>, please fill this form",
      start: "Start the test",
      valider: 'Confirm',
      your_performance: 'Fleet management and field operations',
      your_score: 'Your score is ',
    },
    meta_fields: {
      description: 'Online audit to assess the maturity embedded telematics and optimize the performance of your field operations.',
      title: 'Evaluate the performance of your vehicle fleet and field operations',
    }
  }
}


export const i18n = new VueI18n({
  locale: 'fr', // set locale
  messages
})



// WEBPACK FOOTER //
// ./src/plugins/i18n.js